import { Box, Flex, Text } from "@chakra-ui/react";
import Card from "./Card";
import { SavedFile } from "../types/files.types";
import FileIconPdf from "./icons/files/FileIconPdf";
import { DownloadIcon } from "@chakra-ui/icons";
import { useState } from "react";
import { useMutation } from "react-query";
import { fetchFileContent } from "../mutations/file.mutations";

const DetailCard = ({
	comment,
	documents,
}: {
	comment?: string;
	documents?: SavedFile[];
}) => {
	const [selectedFile, setSelectedFile] = useState<SavedFile | null>(null);
	const { mutate: downloadFileContent } = useMutation(fetchFileContent, {
		onSuccess: (content: string) => {
			const blob = new Blob([content]);
			const link = document.createElement("a");
			link.href = URL.createObjectURL(blob);
			link.download = selectedFile ? selectedFile.fileName : "file";
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		},
		onSettled: () => {
			setSelectedFile(null);
		},
	});

	return (
		<Card w="100%">
			<Flex
				borderTopRadius="xl"
				px={4}
				py={2}
				borderBottom="solid 1px"
				borderColor="gray.200"
				w="100%"
				direction="column"
			>
				<Text
					lineHeight="21px"
					fontSize="16px"
					fontWeight="600"
					py={4}
					borderBottom="solid 1px"
					borderColor="gray.200"
				>
					Détails
				</Text>
				<Flex direction="column" w="100%" mt={2}>
					<Text lineHeight="21px" fontSize="14px" fontWeight="600">
						Commentaire
					</Text>
					{comment && (
						<Text lineHeight="21px" fontSize="14px" fontWeight="300">
							{comment?.trim() !== "" ? comment : "Pas de commentaire"}
						</Text>
					)}
					{!comment && (
						<Text
							lineHeight="21px"
							fontSize="14px"
							fontWeight="300"
							fontStyle="italic"
						>
							Pas de commentaire
						</Text>
					)}

					<Box borderBottom="solid 1px" borderColor="gray.200" py={2}></Box>

					<Text lineHeight="21px" fontSize="14px" fontWeight="600" mt={2}>
						Documents joints
					</Text>
					{(documents === undefined || documents.length === 0) && (
						<Text
							lineHeight="21px"
							fontSize="14px"
							fontWeight="300"
							fontStyle="italic"
						>
							Pas de document joints
						</Text>
					)}
					{documents !== undefined &&
						documents.map((document) => (
							<Flex
								justify="space-between"
								onClick={() => {
									if (selectedFile === null) {
										setSelectedFile(document);
										downloadFileContent(document.id);
									}
								}}
							>
								<Flex gap={4}>
									<FileIconPdf color="brand.700" w="24px" h="24px" />
									<Text>{document.fileName}</Text>
								</Flex>
								<DownloadIcon />
							</Flex>
						))}
				</Flex>
			</Flex>
		</Card>
	);
};

export default DetailCard;
